import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, ControlContainer, Validators } from '@angular/forms';

// RxJS
import { AppState } from '../../app-reducer';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { first, takeUntil } from 'rxjs/operators';

import { validateZip } from 'src/app/validators';

@Component({
  selector: 'address-form',
  templateUrl: './address-form.component.html',
})
export class AddressFormComponent implements OnInit, OnDestroy {
  @Input() parent: FormGroup;
  @Input() isRequired: boolean;
  blockIndex: number = 1;
  disabled: boolean = false;
  private _onDestroy = new Subject();

  public addressFormGroup: FormGroup;
  formGroupParent: any;
  appState$: Observable<any>;
  states: any;
  isDemo = false;
  constructor(
    private controlContainer: ControlContainer,
    private store: Store<AppState>
  ) {
    this.appState$ = store.select('sections');
  }

  ngOnInit() {
    this.addressFormGroup = <FormGroup>this.controlContainer.control;
    this.formGroupParent = this.controlContainer.name;

    // get US states
    this.appState$.pipe(first()).subscribe((state: any) => {
      this.states = state.formData.states;
      if (state.isDemo){
        this.isDemo = true;
        this.setDemoAddress();
      }
    });

    if (!this.isRequired) {
      this.addressFormGroup.controls['Street'].clearValidators();
      this.addressFormGroup.controls['Street2'].clearValidators();
      this.addressFormGroup.controls['City'].clearValidators();
      this.addressFormGroup.controls['State'].clearValidators();
      this.addressFormGroup.controls['Zip'].clearValidators();
      this.addressFormGroup.controls['Zip'].setValidators([Validators.nullValidator,validateZip]);
      this.addressFormGroup.updateValueAndValidity();
    }

    this.addressFormGroup.statusChanges.pipe(takeUntil(this._onDestroy)).subscribe(status => {
      if (status === "DISABLED") {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    });
    
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  setDemoAddress() {
    this.addressFormGroup.patchValue({Street:'200 Berkeley St.', City:'Boston'});
    this.addressFormGroup.controls['Street'].disable();
    this.addressFormGroup.controls['Street2'].disable();
    this.addressFormGroup.controls['City'].disable();
  }

  // address from autocomplete
  updateAddress(event) {
    this.addressFormGroup.patchValue(event);
  }

}
